import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function TimedSettings() {

const { id } = useParams();
const navigate = useNavigate();

// modes: overall | per | hybrid | adaptive
const [mode,setMode] = useState("overall");

const [totalTime,setTotalTime] = useState(20);
const [perQ,setPerQ] = useState(30);
const [adaptiveQ,setAdaptiveQ] = useState(30);

const startTest = ()=>{

navigate(`/timed/${id}`,{
 state:{
  mode,
  totalTime: mode==="overall" || mode==="hybrid" ? totalTime*60 : null,
  perQuestion: mode==="per" ? perQ : null,
  adaptiveTime: mode==="adaptive" ? adaptiveQ : null
 }
});

};

const Card = ({title,active,onClick,children})=>(
<div
onClick={onClick}
className={`p-4 rounded-xl border cursor-pointer transition
${active?"border-blue-600 bg-blue-50":"border-gray-300 bg-white"}`}
>
<div className="flex justify-between items-center mb-2">
<b>{title}</b>
<input type="radio" checked={active} readOnly />
</div>
{active && children}
</div>
);

return(

<div className="min-h-screen bg-slate-100 flex justify-center items-center">

<div className="bg-white w-[520px] rounded-2xl shadow-xl p-6">

<h2 className="text-2xl font-bold text-center mb-6">
⏱ Timed Test
</h2>

<div className="space-y-4">

{/* OVERALL */}

<Card title="Overall Timer" active={mode==="overall"} onClick={()=>setMode("overall")}>

<label className="text-sm">Total Time (minutes)</label>
<input
type="number"
value={totalTime}
onChange={e=>setTotalTime(Number(e.target.value))}
className="mt-1 border w-full p-2 rounded"
/>

</Card>

{/* PER QUESTION */}

<Card title="Per Question Timer" active={mode==="per"} onClick={()=>setMode("per")}>

<label className="text-sm">Per Question (seconds)</label>
<input
type="number"
value={perQ}
onChange={e=>setPerQ(Number(e.target.value))}
className="mt-1 border w-full p-2 rounded"
/>

</Card>

{/* HYBRID */}

<Card title="Hybrid Timer" active={mode==="hybrid"} onClick={()=>setMode("hybrid")}>

<p className="text-sm text-gray-600">
Global timer + recommended per question pacing
</p>

<label className="text-sm mt-2 block">Total Time (minutes)</label>
<input
type="number"
value={totalTime}
onChange={e=>setTotalTime(Number(e.target.value))}
className="mt-1 border w-full p-2 rounded"
/>

</Card>

{/* ADAPTIVE */}

<Card title="Adaptive Timer (AI)" active={mode==="adaptive"} onClick={()=>setMode("adaptive")}>

<label className="text-sm">Base Per Question (sec)</label>
<input
type="number"
value={adaptiveQ}
onChange={e=>setAdaptiveQ(Number(e.target.value))}
className="mt-1 border w-full p-2 rounded"
/>

<p className="text-xs text-gray-500 mt-2">
Difficulty + time will auto adjust.
</p>

</Card>

</div>

{/* SUMMARY */}

<div className="mt-6 bg-gray-100 p-4 rounded-lg text-sm">

<p><b>Mode:</b> {mode}</p>

{mode==="overall" && <p>Total: {totalTime} mins</p>}
{mode==="per" && <p>Per Question: {perQ} sec</p>}
{mode==="hybrid" && <p>Total: {totalTime} mins + pacing</p>}
{mode==="adaptive" && <p>Adaptive base: {adaptiveQ} sec</p>}

</div>

<button
onClick={startTest}
className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold"
>
🚀 Start Test
</button>

</div>

</div>
);
}